import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { AppFooter as LBFooter } from "@loanbossinc/component-library";
import CircularProgress from "@material-ui/core/CircularProgress";

import { PageContainer, FooterContainer, StyledButtonText } from "./styledComponents";
import { TableWrapper, TitleWrapper } from "./dashboard.style";
import { columns } from "./companySpreadColumns";
import DataTable from "./DataTable";
import { getDVSpreadsByCompany, updateDVSpreadsByCompany } from "./debtValuation.store";

const HeaderContentWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const HeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 20px;
`;

const DebtValuationDashboard = ({ getDVSpreadsByCompany, updateDVSpreadsByCompany, debtValuationSettingsForCompany, history }) => {
  const [spreadData, setSpreadData] = useState([]);

  useEffect(() => {
    getDVSpreadsByCompany();
  }, []);

  useEffect(() => {
    setSpreadData(debtValuationSettingsForCompany);
  }, [debtValuationSettingsForCompany]);

  const goToDeal = (dealId, loanId) => {
    const url = `/portfolio/funds/free/deals/${dealId}/cashflowsPage?showActiveLoans=true&loanId=${loanId}&isDebtValuation=true`;
    history.push(url);
  };

  const update = (spread, item) => {
    updateDVSpreadsByCompany({
      loanId: item.loanId,
      debtValuationId: item.debtValuationId,
      spread: spread / 100
    });
  };

  const updateMyData = (rowIndex, columnId, value, e) => {
    setSpreadData(old => old.map((row, index) => {
      if (index === rowIndex) {
        const item = old[rowIndex];
        update(value, item);

        return {
          ...old[rowIndex],
          [columnId]: value
        };
      }

      return row;
    }));
  };

  return (
    <PageContainer>

      <HeaderWrapper>
        <HeaderContentWrapper>
          <HeaderContentWrapper style={{ flexDirection: "column" }}>
            <StyledButtonText label={"Back"} iconName="arrow_forward" onClick={history.goBack} reverse />
          </HeaderContentWrapper>
        </HeaderContentWrapper>
      </HeaderWrapper>

      {spreadData &&
        <TableWrapper>
          <DataTable columns={columns(goToDeal, update)} data={spreadData} showFilter updateMyData={updateMyData} />
        </TableWrapper>}

      {!spreadData && <CircularProgress style={{ margin: "auto" }} />}

      <FooterContainer>
        <LBFooter />
      </FooterContainer>
    </PageContainer>
  );
};

const mapStateToProps = ({ authentication, debtValuation }) => ({
  authentication,
  ...debtValuation
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getDVSpreadsByCompany, updateDVSpreadsByCompany
  })
)(DebtValuationDashboard);
